import React from 'react';

export const howItWorksSteps = [
  {
    num: "01",
    title: "Choose your service",
    text: "Pick VPN access, travel data or a UK/USA number."
  },
  {
    num: "02",
    title: "Choose your plan",
    text: "Select your duration, destination and any optional extras."
  },
  {
    num: "03",
    title: "Pay securely",
    text: "Complete checkout using one of the supported payment methods."
  },
  {
    num: "04",
    title: "Get connected",
    text: "After payment, save the access code shown on screen. Enter it in the PhantomPath Portal to activate and manage your service."
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="pt-10 pb-8 px-4 md:pt-12 md:pb-10 bg-[#0a0a0a] relative">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">How It Works</h2>
        </div>

        <div className="grid grid-cols-1 items-stretch gap-8 md:grid-cols-2 lg:grid-cols-4">
          {howItWorksSteps.map((step, index) => (
            <div key={step.num} className="relative h-full self-start">
              {index < howItWorksSteps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-[#1a1a1a] -z-10"></div>
              )}

              <div className="flex h-full flex-col items-center justify-start text-center">
                <div className="relative z-10 mb-6 flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-[#3affc2]/30 bg-[#111] text-xl font-bold text-[#3affc2]">
                  {step.num}
                </div>
                <h3 className="mb-3 flex min-h-[3.5rem] items-start justify-center border-b-2 border-[#3affc2]/70 pb-1 text-lg font-bold text-white">{step.title}</h3>
                <p className="text-sm text-[#f4fbff] leading-relaxed max-w-[220px]">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
